// extracted by mini-css-extract-plugin
export default {"container":"CommercialBlock-container__WQ7c","title":"CommercialBlock-title_HlxuD","points":"CommercialBlock-points_vV_XI"};